import { render, staticRenderFns } from "./absolute-without-activator.vue?vue&type=template&id=dd7047ae&scoped=true&"
import script from "./absolute-without-activator.vue?vue&type=script&lang=js&"
export * from "./absolute-without-activator.vue?vue&type=script&lang=js&"
import style0 from "./absolute-without-activator.vue?vue&type=style&index=0&id=dd7047ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7047ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VList,VListItem,VListItemTitle,VMenu,VRow})
